module.exports = __webpack_public_path__ + "static/media/icon_favorite_yellow.1bbc3b63.png";